import React, { Component } from 'react';

class Header extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url} target="_blank"><i className={network.className}></i></a></li>
      })
    }

    return (
      <header id="home">

      <nav id="nav-wrap">
         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>
         <div className="logo_div_mobile"><a href="#home"><img src="../images/logo.png.jpeg" width="100px"></img></a></div>
         <ul id="nav" className="nav">
            <div className="logo_div"><a href="#home"><img src="../images/mutual_street_logo_original_auto_x3.png" width="100px"></img></a></div>
            <li className="current"><a className="smoothscroll" href="#home">HOME</a></li>
            <li><a className="smoothscroll" href="#about">ABOUT US</a></li>
	         <li><a className="smoothscroll" href="#resume">SERVICES</a></li>
            <li><a className="smoothscroll" href="#expertise">EXPERTISE</a></li>
            <li><a className="smoothscroll" href="#portfolio">FOUNDER</a></li>
            <li><a className="smoothscroll" href="#partner">PARTNERS</a></li>
            <li><a className="smoothscroll" href="#contact">CONTACT</a></li>
         </ul>
      </nav>

      <div className="row banner">
      
         <div className="banner-text">
            
            {/*<h1 className="responsive-headline">name</h1>*/}
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>
   
      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>
      
   </header>
    );
  }
}

export default Header;
